import {useMutation} from "@tanstack/react-query";
import {readExchangeRateForPeriod} from "../../../../../api/main/OcApi";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";

export const useReadExchangeRateForPeriod = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: {
            startAt: string
            endAt: string
        }) => readExchangeRateForPeriod(data),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    })

    return {mutate, mutateAsync}
};
